<template>
    <div class="popup-auth">
        <div class="popup-auth__content">
            <h3 class="popup-auth__title popup__title" v-if="!Helpers.isMobile()">
                Авторизуйтесь через одну<br>
                из социальных сетей, чтобы войти:
            </h3>
            <h3 class="popup-auth__title popup__title" v-else>
                Авторизуйтесь через<br> одну
                из социальных сетей,<br> чтобы войти:
            </h3>
            <div class="popup-auth__socials">
                <socials-auth></socials-auth>
            </div>
        </div>
    </div>
</template>

<script>
    import SocialsAuth from '@/components/common/SocialsAuth'
    import Helpers from '@/tools/Helpers';
    export default {
        name: 'InfoWithBtn',
        components: {
            SocialsAuth
        },
        data(){
            return {
                Helpers
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Auth.vue?26266f12